import React, { useState } from 'react';
import { MapContainer, AttributionControl, Popup, Marker, Polygon, Polyline, Circle } from "react-leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import LayerControl from '../map/layer-control';

import { generateIcon } from '../map/marker';


const Map = ({ data, defaultCentre = [-41.2924, 174.7787], defaultZoom = 6 }) => {

  return (
    <output className="overflow-hidden">
      <MapContainer
        className="markercluster-map"
        center={defaultCentre}
        zoom={defaultZoom}
        maxZoom={18}
        minZoom={3}
        attributionControl={false}
        whenReady={({ target:map }) => {
          map.gestureHandling.enable();

          // a11y (?) move the controls above the map in the source order
          const mapPane = document.querySelector('.leaflet-map-pane');
          const controls = document.querySelector('.leaflet-control-container');
          mapPane.before(controls);
        }}
      >
        <LayerControl />

        {data.map(item => (
          <MarkerWithState key={item.nid} item={item} />
        ))}
        <AttributionControl position="bottomright" prefix={false} />
      </MapContainer>
    </output>
  )
}

export default Map;

const invertCoordinates = (coordinates) => {
  // Check if it's a MultiPolygon (depth 3+)
  if (Array.isArray(coordinates[0][0][0])) {
    // MultiPolygon: depth is 3D (array of polygons, each with rings)
    return coordinates.map(polygon =>
      polygon.map(ring =>
        ring.map(([lat, lng]) => [lng, lat])
      )
    );
  } else if (Array.isArray(coordinates[0][0])) {
    // Polygon: depth is 2D (array of rings)
    return coordinates.map(ring =>
      ring.map(([lat, lng]) => [lng, lat])
    );
  } else {
    // Single Point: Just swap lat and lng
    return [coordinates[1], coordinates[0]];
  }
};


const MarkerWithState = ({ item, ...props }) => {
  const [ isOpen, setIsOpen ] = useState(false);

  const attrs = {
    keyboard: false,
    pathOptions: {
      color: "magenta",
      fillColor:"magenta",
      fillOpacity: 0.5
    }
  }


  switch (item.geodata.type) {
    case "Point":
      return (
        <Marker
          {...attrs}
          position={item.geodata.coordinates.reverse()}
          icon={generateIcon('magenta', `Open ${item.title}`, false)}
          >
          <Popup>
            <h3 className="mt-0 mb-2"><a href={item.path}>{item.title}</a></h3>
          </Popup>
        </Marker>
      );
      break;

    case 'Polygon':
    case 'MultiPolygon':
      const latlng = invertCoordinates(item.geodata.coordinates);

      return (
        <Polygon {...attrs} positions={latlng}>
          <Popup>
            <h3 className="mt-0 mb-2"><a href={item.path}>{item.title}</a></h3>
          </Popup>
        </Polygon>
      );
      break;

    case 'LineString':
      return (
        <Polyline {...attrs} positions={L.GeoJson.coordsToLatLngs(item.geodata.coordinates)}>
          <Popup>
            <h3 className="mt-0 mb-2"><a href={item.path}>{item.title}</a></h3>
          </Popup>
        </Polyline>
      );
      break;

    default:
      return null;
      break;
  }

  /*return (
    <Marker
      eventHandlers={{
        popupopen: (e) => setIsOpen(true),
        popupclose: (e) => setIsOpen(false),
      }}
      icon={item.field_tenure_review_state === '1' ? generateIcon('teal', `Open ${item.title}`, isOpen) : generateIcon('grey', `Open ${item.title}`, isOpen)}
      keyboard={false}
      position={[item.latitude, item.isCloseToAntimeridian ? item.longitude + 360 : item.longitude]}>
        <Popup className={item.field_tenure_review_state === '1' ? 'has-teal-icon' : 'has-gray-icon'}>
          <h3 className="mt-0 mb-2"><a href={item.view_node}>{item.title}</a></h3>
        </Popup>
    </Marker>
  )*/
}
